import $ from 'jquery';

$(function(){

 

});